// src/redux/auth/authSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { getAuthUserData } from "../../localStorage";

const initialAuthUserData = getAuthUserData();

const initialState = {
  user: initialAuthUserData ? initialAuthUserData : null,
  isAuthenticated: initialAuthUserData ? Boolean(initialAuthUserData) : false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.error = null;
    },
    clearUser(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.error = null;
    },
    setError(state, action) {
      state.error = action.payload;
    },
  },
});

export const { setUser, clearUser, setError } = authSlice.actions;
export default authSlice.reducer;
